// R10e36.68-F822: Central brand configuration
// Change strings here to update the entire frontend.

export const BRAND = {
  // Legal entity (footer only, both surfaces)
  legalEntity: 'Real Estate Connect Technologies, LLC',
  legalEntityShort: 'REC Technologies',

  // Public portal (paezproptax.com surface)
  publicPortalName: 'paezproptax.com',
  publicPortalTagline: 'PA Property Tax Certificates',
  publicPortalUrl: 'https://paezproptax.com',

  // Collector app (white-label surface)
  // The header should show the COLLECTOR'S name, not this.
  // These strings only appear on generic pages (login/register before login)
  collectorAppNeutralName: 'Tax Collector Portal',
  collectorAppTagline: 'PA Act 48 Collection System',

  // Support / contact
  supportEmail: 'support@paezproptax.com',
};
